import { isPast } from 'date-fns';
import { WHALE_URL } from '@/constants/bookmakers';
import { Game } from '@/constants/game.const';
import type { Tournament } from '@/types/tournament';

const hardcodedTournaments: Tournament[] = generateHardcodedTournaments();

export const getActiveTournaments = () =>
  hardcodedTournaments.filter((t) => !hasTournamentPassed(t));

export const getPastTournaments = () =>
  hardcodedTournaments.filter(hasTournamentPassed);

function generateHardcodedTournaments() {
  const tournaments: Tournament[] = [];

  if (process.env.ESPORTS_WORLD_CUP_TOURNAMENT_ID) {
    tournaments.push({
      id: process.env.ESPORTS_WORLD_CUP_TOURNAMENT_ID,
      name: 'Esports World Cup',
      startDateTime: '2025-08-20T22:00:00+00:00',
      endDateTime: '2025-08-24T22:16:15+00:00',
      slug: 'esports-world-cup',
      game: Game.CS2,
      prizePool: '500$',
      poweredBy: {
        name: 'whale.io',
        url: WHALE_URL,
        logo: {
          url: '/tournaments/whale_logo.webp',
          height: 640,
          width: 1280,
        },
        icon: {
          url: '/tournaments/whale_icon.webp',
          height: 136,
          width: 124,
        },
        bannerSmall: {
          url: '/tournaments/whale_banner_small.webp',
          height: 96,
          width: 760,
        },
        bannerLarge: {
          url: '/tournaments/whale_banner_large.webp',
          height: 248,
          width: 1770,
        },
      },
      nameImage: {
        url: '/tournaments/esports_world_cup_title.webp',
        height: 80,
        width: 408,
      },
      additionalImageRight: {
        url: '/tournaments/esports_world_cup_trophy.webp',
        height: 322,
        width: 267,
      },
      isDefaultBgDisplayed: false,
      rewards: [
        {
          label: 'USP-S | Kill Confirmed (Factory New)',
          price: '$199',
          imagePath: '/rewards/tournaments/esports-world-cup/1.webp',
        },
        {
          label: 'Desert Eagle | Printstream (Factory New) ',
          price: '$116',
          imagePath: '/rewards/tournaments/esports-world-cup/2.webp',
        },
        {
          label: 'AK-47 | Frontside Misty (Factory New) ',
          price: '~$95 - 106',
          imagePath: '/rewards/tournaments/esports-world-cup/3.webp',
        },
        {
          label: 'M4A4 | Neo-Noir (Factory New)',
          price: '~$66 - 72',
          imagePath: '/rewards/tournaments/esports-world-cup/4.webp',
        },
        {
          label: 'AWP | Mortis (Factory New)',
          price: '~$13 - 15',
          imagePath: '/rewards/tournaments/esports-world-cup/5.webp',
        },
      ],
    });
  }

  return tournaments;
}

export function hasTournamentPassed(tournament: Tournament): boolean {
  return isPast(tournament.endDateTime);
}

export function hasTournamentStarted(tournament: Tournament): boolean {
  return isPast(tournament.startDateTime);
}

export function isTournamentActive(tournament: Tournament): boolean {
  return hasTournamentStarted(tournament) && !hasTournamentPassed(tournament);
}

export function getTournamentBy(
  needle: string,
  key: keyof Tournament
): Tournament | undefined {
  return hardcodedTournaments.find((t) => t[key] === needle);
}

export function getFirstActiveTournament(): Tournament | undefined {
  return hardcodedTournaments.find(isTournamentActive);
}
